import React, {useContext} from 'react'
import {IconSettings} from '@salesforce/design-system-react'

import {MessagesContext} from '../context/messagesContext'

const ItemLink = ({title, id, type}) => {
	const {displayObject} = useContext(MessagesContext)
	
	return (
		<a
			href='#'
			onClick={ () => displayObject(id, type)}
		>
			{title}
		</a>
	)
}

const ListItem = ({label, value}) => {
	return (
		<li className="tableRowGroup" key={label}>
			<div className="slds-list--horizontal forceListRecordItem">
				<div className="slds-item--label slds-truncate recordCell">
				{label}:</div>
				<div className="slds-item--detail slds-truncate recordCell">
					{value}
				</div>
			</div>
		</li>
	)
}

const RelatedItem = ({item}) => {

	const detailItems = () => {
		const renderList = []
		for (const [key, value] of Object.entries(item.details)) {
			renderList.push(<ListItem key={key} label={key} value={value} />)
		}
		return renderList
	}

	return (
		<IconSettings iconPath="/icons">
			<div className="related-item">
				<div><ItemLink title={item.title} id={item.id} type={item.type} /></div>
				<ul className="itemRows truncate">
					{detailItems()}
				</ul>
			</div>
		</IconSettings>
	)
}

export default RelatedItem
		